export type CurrentConditionIndicator = 'ILLNESS' | 'INJURY' | 'PREGNANCY';

/**
 * Array of all CurrentConditionIndicator values.
 */
export const CURRENTCONDITIONINDICATOR_VALUES: readonly CurrentConditionIndicator[] =
  ['ILLNESS', 'INJURY', 'PREGNANCY'] as const;
